module.exports = __webpack_public_path__ + "img/144.5.3b93e953.png";